// src/components/Footer.js
import React from 'react'
import {
  Linkedin,
  Github,
  Mail,
  Phone,
  MessageCircle,
  ArrowUpRight,
} from 'lucide-react'
import { Link } from 'react-router-dom'
import logo from '../Images/LogoOM.PNG'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-slate-950 pt-20 pb-10 relative overflow-hidden">
      {/* Background Decorative Logo - Industrial Watermark */}
      {/* <div className="absolute right-[-5%] bottom-[-10%] opacity-[0.03] pointer-events-none">
        <img src={logo} alt="" className="w-96 h-96 grayscale" />
      </div> */}

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 border-b border-white/10 pb-16">
          {/* 1. BRANDING & STATUS */}
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3 group mb-6">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center transition-transform group-hover:rotate-12">
                <img src={logo} alt="Logo" className="w-8 h-8 object-contain" />
              </div>
              <span className="text-2xl font-black text-white tracking-tighter uppercase">
                Omkar More
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-8">
              Strategizing the intersection of digital infrastructure and
              industrial precision. Providing high-precision NDT inspections and
              modern SaaS solutions.
            </p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/20">
                <span className="w-2 h-2 rounded-full bg-cyan-500 animate-pulse"></span>
                <span className="text-[10px] font-black text-cyan-500 uppercase tracking-widest">
                  Available for Projects
                </span>
              </div>
            </div>
          </div>

          {/* 2. NAVIGATION INDEX */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-black text-white uppercase tracking-[0.3em] mb-8">
              Site Index
            </h4>
            <ul className="grid grid-cols-1 gap-4">
              {[
                'Home',
                'Ventures',
                'Journey',
                'Projects',
                'Services',
                'Tools',
              ].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="text-slate-400 hover:text-cyan-500 text-xs font-bold uppercase tracking-widest transition-colors flex items-center justify-between group"
                  >
                    {item}
                    <ArrowUpRight
                      size={14}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 3. CONTACT & CONNECT */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-black text-white uppercase tracking-[0.3em] mb-8">
              Secure Connection
            </h4>
            <div className="space-y-6">
              {/* Communication Channels */}
              <div className="flex flex-wrap gap-4">
                {[
                  {
                    icon: <Phone size={20} />,
                    href: 'tel:+919930405472',
                    label: 'Call',
                  },
                  {
                    icon: <MessageCircle size={20} />,
                    href: 'https://wa.me/919930405472',
                    label: 'WhatsApp',
                  },
                  {
                    icon: <Linkedin size={20} />,
                    href: 'https://www.linkedin.com/in/omkar-more-379984214/',
                    label: 'LinkedIn',
                  },
                  {
                    icon: <Github size={20} />,
                    href: 'https://github.com/OmkarMore278/',
                    label: 'GitHub',
                  },
                  {
                    icon: <Mail size={20} />,
                    href: 'mailto:moreomkar972@gmail.com',
                    label: 'Email',
                  },
                ].map((social, i) => (
                  <a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-slate-300 hover:bg-cyan-600 hover:text-white hover:border-cyan-600 transition-all"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>

              <div className="p-6 rounded-2xl bg-white/[0.02] border border-white/5">
                <span className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">
                  Direct Inquiry
                </span>
                <a
                  href="mailto:moreomkar972@gmail.com"
                  className="text-white font-bold hover:text-cyan-500 transition-colors"
                >
                  moreomkar972@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-[10px] font-bold uppercase tracking-[0.2em]">
            © {currentYear} Omkar More{' '}
            <span className="mx-2 text-slate-800">|</span> Mumbai, India
          </p>
          <div className="flex gap-8">
            {/* <span className="text-slate-600 text-[9px] font-black uppercase tracking-widest">v2.6.0 Build</span> */}
            {/* Change this span to a Link */}
            <Link
              to="/privacy"
              className="text-slate-600 text-[9px] font-black uppercase tracking-widest underline underline-offset-4 hover:text-slate-400"
            >
              Privacy Policy
            </Link>{' '}
          </div>
        </div>
      </div>
    </footer>
  )
}
